import styled from "styled-components";
// import { format } from 'date-fns';
import { Key, useState } from 'react';
import { LabsGameProposalPreviewAPI } from "../TestManagementApi";
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

const Main = styled.main`
  background-color: white;
  width: 100%;
  display: flex;
  justify-content: center;
  overflow-y: auto;
  margin-bottom: 100px;
`;

const Container = styled.div`
  width: 100%;
  max-width: 420px;
  height: 88vh;
  margin-top: 1vh;
  background: white;
  position: relative;
  border-radius: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  // overflow-y: auto;
`;

const SubUpsideContainer = styled.div`
  width: 100%;
  max-width: 420px;
  height: 90%;
  background: white;
  position: relative;
  border: 1px solid #E0E0E0;
  border-radius: 16px;
  margin-bottom: 1px;
  overflow-y: auto;
`;


const StatusBar = styled.div`
  height: 44px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  background: white;
`;

const LeftStatus = styled.div`
  font-weight: 600;
`;

const RightStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const NetworkIcon = styled.div`
  display: flex;
  align-items: flex-end;
  height: 12px;
  gap: 1px;
  
  span {
    width: 3px;
    background: black;
    border-radius: 0;
    
    &:nth-child(1) { height: 4px; }
    &:nth-child(2) { height: 6px; }
    &:nth-child(3) { height: 8px; }
    &:nth-child(4) { height: 10px; }
  }
`;

const BatteryIcon = styled.div`
  width: 22px;
  height: 12px;
  border: 1px solid black;
  border-radius: 2px;
  position: relative;
  margin-left: 4px;
  display: flex;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  
  &:after {
    content: '';
    position: absolute;
    right: -3px;
    top: 3px;
    width: 2px;
    height: 4px;
    background: black;
    border-radius: 0 1px 1px 0;
  }
`;

const Header = styled.div`
  padding: 16px;
`;

const BackButton = styled.button`
  border: none;
  background: none;
  font-size: 20px;
  padding: 0;
  margin-bottom: 16px;
  cursor: pointer;
  color: #333;
`;

const DateRange = styled.div`
  display: flex;
  justify-content: space-between;
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
`;

const CategoryText = styled.span`
  color: #666;
  font-size: 14px;
  display: block;
  margin-bottom: 16px;
  padding-top: 8px;
`;

const GameInfo = styled.div`
  display: flex;
  gap: 12px;
  padding: 0 16px 0 5px;
`;

const CBTGameIcon = styled.img`
margin-left: -10%;
  width: 30%;
  height: 64px;
  border-radius: 12px;
`;
const GameIcon = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 12px;
`;

const GameDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const GameCategory = styled.span`
  color: #666;
  font-size: 13px;
  margin-bottom: 4px;
`;

const GameTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
`;

const TagContainer = styled.div`
  display: flex;
  gap: 6px;
`;

const Tag = styled.span`
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  background: #333;
  color: white;
`;

const VideoContainer = styled.div`
  position: relative;
  width: calc(100% - 32px);
  margin: 0 16px;
  padding-top: 56.25%; /* 16:9 비율 */
`;

const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 90%;
  border: none;
  border-radius: 12px;
`;

const NoVideoMessage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F8F9FA;
  border-radius: 12px;
  color: #666;
  font-size: 14px;
`;

const ThumbnailGrid = styled.div`
  display: flex;
  gap: 8px;
  padding: 4px 16px 16px 16px;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Thumbnail = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
`;

const RewardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-top: 1px solid #eee;
  gap: 3%;
`;

const RewardItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #E0E0E0;
  border-radius: 12px;
  padding: 14px;
`;

const RewardLabel = styled.span`

  color: #666;
  font-size: 12px;
  padding-right: 30px;
`;

const RewardValue = styled.span`
  color: #2282E9;
  font-size: 14px;
  font-weight: 600;
`;

const TryButton = styled.button`
  width: calc(100% - 32px);
  margin: 16px;
  height: 70px;
  background: #2282E9;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 0 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const ButtonTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 4px;
`;

const ButtonSubtitle = styled.span`
    padding-top: 4px;
  font-size: 12px;
  opacity: 0.8;
`;

const ArrowIcon = styled.div`
  position: absolute;
  right: 30px;
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2282E9;
  font-size: 14px;
  padding-left: 1px;
  padding-top: 1px;
`;

const GameDescription = styled.div`
  padding: 16px;
  border-top: 1px solid #E0E0E0;

  margin-bottom: 20px;
`;

const DescriptionTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const ExpandIcon = styled.span<{ isOpen: boolean }>`
  font-size: 20px;
  color: #666;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0)'};
  transition: transform 0.3s ease;
`;

const DescriptionContent = styled.div<{ isOpen: boolean }>`
  max-height:0;
  overflow: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: max-height 0.3s ease-in-out;
  
  p {
    margin: 0;
    padding: ${props => props.isOpen ? '20px 0' : '0'};
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.5;
  }
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 2px;
  background-color: #E0E0E0;
  margin-top: 8px;
  position: relative;
  padding-top: 6px;
`;

const ProgressBar = styled.div<{ progress: number }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: ${props => props.progress}%;
  background-color: #2282E9;
  transition: width 0.3s ease;
`;

const CBTContainer = styled.div<{ backgroundUrl: string; show: boolean }>`
  width: 100%;
  height: 90%;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
              url(${props => props.backgroundUrl}) no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  transform: translateX(${props => (props.show ? '0%' : '100%')});
  z-index: 10;
  border-radius: 16px;
`;

const CBTInnerContainer = styled.div`
  width: 90%;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

const CBTHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 5%;
`;

const CBTBackButton = styled.button`
  position: absolute;
  top: 50px;
  left: 20px;
  border: none;
  background: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  z-index: 1;
`;

const CBTTitle = styled.h1`
  font-size: 18px;
  color: white;
  margin: 0;
`;

const CBTDate = styled.div`
  font-size: 14px;
  color: #cccccc;
  margin-top: 4px;
`;
const CBTLittleDescription = styled.div`
  font-size: 12px;
  color: #cccccc;
  margin-top: 4px;
`;

const CBTNumberDiv = styled.div`
  background-color: #333;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  color: white;
  height: 300px;
  // height: 00%;
  display: flex;
`;


const CBTButton = styled.button`
  width: 100%;
  height: 48px;
  background: #2282E9;
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 7%;
`;

const IconContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
`;

const DayIcon = styled.div`
  background-color: #2282E9;
  color: white;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 10px;
`;

const PointIcon = styled.div`
  background-color: #f0f0f0;
  color: black;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 10px;
`;

const genre = [
  { id: "TRPG_GAME", content: "TRPG" },
  { id: "RPG_GAME", content: "RPG" },
  { id: "ADVENTURE_GAME", content: "어드벤처 게임" },
  { id: "SANDBOX_GAME", content: "샌드박스" },
  // { id: "EVENT_GAME", content: "이벤트" },
  { id: "ACTION_GAME", content: "액션 게임" },
  { id: "ROGUE_LITE_GAME", content: "로그라이트" },
  { id: "SHOOTING_GAME", content: "슈팅 게임" },
  { id: "AOS_GAME", content: "AOS 게임" },
  { id: "RTS_GAME", content: "RTS 게임" },
  { id: "DEFENSE_GAME", content: "디펜스" },
  { id: "TURN_BASE_GAME", content: "턴제 게임" },
  { id: "STRATEGY_GAME", content: "전술" },
  { id: "MANAGEMENT_GAME", content: "경영(타이쿤)" },
  { id: "SIMULATION_GAME", content: "시뮬레이션" },
  { id: "MERGE_GAME", content: "머지(merge-합성)" },
  { id: "FARMING_GAME", content: "농사" },
  { id: "PUZZLE_GAME", content: "퍼즐 게임" },
  { id: "ARCADE_GAME", content: "아케이드" },
  { id: "RACING_GAME", content: "레이싱 게임" },
  { id: "SPORTS_GAME", content: "스포츠 게임" },
  { id: "IDLE_TYPE_GAME", content: "방치형" },
  { id: "CASUAL", content: "캐주얼" },
  { id: "NONE", content: "선택안함" }
];

const getGenreDisplayName = (genreId: string) => {
  const foundGenre = genre.find(item => item.id === genreId);
  return foundGenre ? foundGenre.content : genreId;
};

const formatYoutubeUrl = (url: string): string => {
  // 이미 완전한 URL인 경우 그대로 반환
  if (url.startsWith('http://') || url.startsWith('https://')) {
    // YouTube 임베딩 URL 형식으로 변환 (필요시)
    if (url.includes('youtube.com/watch?v=')) {
      const videoId = url.split('v=')[1]?.split('&')[0];
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }
    return url;
  }

  // YouTube 동영상 ID로 간주하고 임베딩 URL 생성
  if (/^[a-zA-Z0-9_-]{11}$/.test(url)) {
    return `https://www.youtube.com/embed/${url}`;
  }

  // 그 외 경우, 일반 문자열을 동영상 ID로 간주
  return `https://www.youtube.com/embed/${url}`;
}

// MainContainer를 추가하여 메인 컨텐츠에 슬라이드 효과 적용
const MainContainer = styled.div<{ hide: boolean }>`
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
  transform: translateX(${props => (props.hide ? '100%' : '0%')});
`;

const PreviewExitButton = styled.button`
  position: fixed;
  top: 20%;
  right: 15%;
  width: 160px;
  height: 55px;
  border-radius: 5px;
  background-color: #2282E9;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  z-index: 2;
  
  &:hover {
    background-color: #1a6abf;
  }
`;

export default function TestPreview() {
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [showCBT, setShowCBT] = useState(false);
  const { gameProposalId } = useParams();
  console.log(`gameProposalId: ${gameProposalId}`);
  interface GameProposalPreviewResponse {
    title: string;
    startedAt: string;
    expiredAt: string;
    company: string;
    thumbnailUrl: string;
    genres: string[];
    youtubeLink: string;
    gameImageUrls: string[];
    rewards: number;
    exp: number;
    cbtDescription: string;
    description: string;

    backgroundUrl: string;
    desiredTesterCount: number;
  }


  const { data: previewData } = useQuery<GameProposalPreviewResponse>({
    queryKey: ["gameProposalPreviewData", gameProposalId],
    queryFn: async () => {
      const response = await LabsGameProposalPreviewAPI(Number(gameProposalId));
      return response.data;
    },
    enabled: true
  });

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}. ${String(date.getMonth() + 1).padStart(2, '0')}. ${String(date.getDate()).padStart(2, '0')}`;
  };

  const handleTryButtonClick = () => {
    setShowCBT(true);
  };

  const handleBackClick = () => {
    setShowCBT(false);
  };

  const handleDescriptionClick = () => {
    setIsDescriptionOpen(!isDescriptionOpen);

    // isOpen이 true가 될 때만 스크롤 실행
    if (!isDescriptionOpen) {
      setTimeout(() => {
        const container = document.querySelector('.subupsidecontainer');
        if (container) {
          container.scrollTo({
            top: container.scrollHeight,
            behavior: 'smooth'
          });
        }
      });
    }
  };

  if (!previewData) return null;

  return (
    <Main>
      <Container>
        <PreviewExitButton onClick={() => window.history.back()}>
          미리보기 종료
        </PreviewExitButton>
        <CBTContainer backgroundUrl={previewData.backgroundUrl} show={showCBT}>
          <CBTInnerContainer>
            <CBTBackButton onClick={handleBackClick}>{'<'}</CBTBackButton>
            <CBTHeader>
              <CBTGameIcon src={previewData.thumbnailUrl} alt="게임 아이콘" />
              <div style={{ paddingLeft: '5%' }}>
                <IconContainer>
                  <DayIcon>D-14</DayIcon>
                  <PointIcon>{previewData?.rewards.toLocaleString()}P</PointIcon>
                </IconContainer>
                <CBTLittleDescription>{previewData.company}</CBTLittleDescription>
                <CBTTitle>{previewData.title}</CBTTitle>
                <CBTDate>
                  {formatDate(previewData.startedAt)} - {formatDate(previewData.expiredAt)}
                </CBTDate>
              </div>
            </CBTHeader>
            <CBTNumberDiv>
              <span>{previewData.cbtDescription}</span>
            </CBTNumberDiv>
            <CBTButton>
              <span>CBT 참여하기</span>
              <span>00/{previewData.desiredTesterCount}명</span>
            </CBTButton>
          </CBTInnerContainer>
        </CBTContainer>

        <MainContainer hide={showCBT}>
          <SubUpsideContainer className="subupsidecontainer">

            <StatusBar>
              <LeftStatus>9:36</LeftStatus>
              <RightStatus>
                <NetworkIcon>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </NetworkIcon>
                <BatteryIcon>80</BatteryIcon>
              </RightStatus>
            </StatusBar>
            <Header>
              <BackButton>{'<'}</BackButton>
              <DateRange>
                <span>{formatDate(previewData.startedAt)} 부터</span>
                <span>{formatDate(previewData.expiredAt)} 까지</span>
              </DateRange>
              <ProgressBarContainer>
                <ProgressBar progress={30} />
              </ProgressBarContainer>
              <CategoryText>진행중 {'>>'}</CategoryText>
              <GameInfo>
                <GameIcon src={previewData.thumbnailUrl} alt="게임 아이콘" />
                <GameDetails>
                  <GameCategory>{previewData.company}</GameCategory>
                  <GameTitle>{previewData.title}</GameTitle>
                  <TagContainer>
                    {previewData.genres.map((genre: string, index: Key | null | undefined) => (
                      <Tag key={index}>{getGenreDisplayName(genre)}</Tag>
                    ))}
                  </TagContainer>
                </GameDetails>
              </GameInfo>
            </Header>

            <VideoContainer>
              {previewData.youtubeLink ? (
                <Video
                  src={formatYoutubeUrl(previewData.youtubeLink)}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <NoVideoMessage>
                  동영상이 없습니다.
                </NoVideoMessage>
              )}
            </VideoContainer>

            <ThumbnailGrid>
              {previewData.gameImageUrls.map((url, index) => (
                <Thumbnail
                  key={index}
                  src={url}
                  alt={`게임 스크린샷 ${index + 1}`}
                />
              ))}
            </ThumbnailGrid>

            <RewardContainer>
              <RewardItem>
                <RewardLabel>포인트 적립</RewardLabel>
                <RewardValue>{previewData.rewards.toLocaleString()}P</RewardValue>
              </RewardItem>
              <RewardItem>
                <RewardLabel>획득 경험치</RewardLabel>
                <RewardValue>{previewData.exp.toLocaleString()}EXP</RewardValue>
              </RewardItem>
            </RewardContainer>

            <TryButton onClick={handleTryButtonClick}>
              <ButtonTitle>CBT 신청하기</ButtonTitle>
              <ButtonSubtitle>모집 기간 내에 CBT를 신청하세요!</ButtonSubtitle>
              <ArrowIcon>{'▶'}</ArrowIcon>
            </TryButton>

            <GameDescription>
              <DescriptionTitle onClick={handleDescriptionClick}>
                <span>게임 설명</span>
                <ExpandIcon isOpen={isDescriptionOpen}>∨</ExpandIcon>
              </DescriptionTitle>
              <DescriptionContent isOpen={isDescriptionOpen}>
                <p>{previewData.description}</p>
              </DescriptionContent>
            </GameDescription>
          </SubUpsideContainer>
        </MainContainer>
      </Container>
    </Main>
  );
}